import {Injectable} from '@angular/core';
import {forkJoin, tap} from 'rxjs';
import {BaseService} from '../../api/base.service';
import {SessionStorageService} from './session-storage.service';
import {storageKey} from '../../api/enum/storage.constants';
import {InstituteService} from '../../api/institute.service';

@Injectable({providedIn: 'root'})
export class AppInitService {
  constructor(
    private baseApi: BaseService,
    private instituteApi: InstituteService,
    private storage: SessionStorageService
  ) {
  }

  init() {
    return forkJoin({
      enumData: this.baseApi.getBaseEnum(),
      cityStateData: this.baseApi.getCityState(),
      instituteEnumData: this.instituteApi.getInstituteEnum(),
    }).pipe(
      tap(data => {
        this.storage.set(storageKey.enumData, data.enumData);
        this.storage.set(storageKey.cityState, data.cityStateData);
        this.storage.set(storageKey.instituteEnumData, data.instituteEnumData);
      })
    );
  }
}
